import FlashCardLanding from './FlashCardLanding/FlashCardLanding.store';
import FlashCardDetail from './FlashCardDetail/FlashCardDetail.store';

export default {
  namespaced: true,
  modules: {
    FlashCardLanding,
    FlashCardDetail,
  },
};
